import { render, staticRenderFns } from "./Diagnosis.vue?vue&type=template&id=bf1e4ab4&scoped=true"
import script from "./Diagnosis.vue?vue&type=script&lang=js"
export * from "./Diagnosis.vue?vue&type=script&lang=js"
import style0 from "./Diagnosis.vue?vue&type=style&index=0&id=bf1e4ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1e4ab4",
  null
  
)

export default component.exports